/**
 * PDP product Info Component is the right-hand section of the Product Detail Page
 * Consists of methods required to format the product response
 */

import _ from 'lodash';
import globals from '../../../common/globals';
import vxModal from '../../../common/vx-modal/vx-modal.vue';
import flyoutBannerMixin from '../../../common/vx-flyout-banner/vx-flyout-banner-mixin';
import ProductMixin from '../../../common/mixins/product-mixin';
import mobileMixin from '../../../common/mixins/mobile-mixin';
import {
  eventBus,
} from '../../../../modules/event-bus';
import {
  ProductAvailability,
  favorites,
  flyoutStatus,
  pdpVariantTypes,
  referenceTypes,
} from '../../../common/mixins/vx-enums';
import AnalyticsService from '../../../common/services/analytics-service';
import PdpService from '../../../common/services/pdp-service';
import vxSpinner from '../../../common/vx-spinner/vx-spinner.vue';
import vxStarRating from '../../../common/vx-star-rating/vx-star-rating.vue';
import cookiesMixin from '../../../common/mixins/cookies-mixin';

export default {
  name: 'vx-pdp-product-info',
  mixins: [
    flyoutBannerMixin,
    ProductMixin,
    mobileMixin,
    cookiesMixin,
  ],
  components: {
    vxModal,
    vxSpinner,
    vxStarRating,
  },
  props: {
    // Details of the products
    pdpProductInfoData: {
      type: Object,
      default: {},
    },
    // Copy text coming from properties files
    i18n: {
      type: Object,
    },
    // indicates whether the site is configured for favorites
    isFavorites: {
      type: Boolean,
      default: false,
    },
    // Id of the product
    productId: {
      type: String,
      default: '',
    },
    // indicates whether social share is enabled
    isSocialShare: {
      type: Boolean,
      default: false,
    },
    // indicates whether sample cart is enabled
    isSampleCart: {
      type: Boolean,
      default: false,
    },
    // indicates whether the site is configured for Bazaar Voice
    isBazaarVoice: {
      type: String,
      default: '',
    },
    // indicates whether the site is configured for pdf download
    showDownload: {
      type: String,
      default: '',
    },
    // colorcodes for pdf download
    colorCodes: {
      type: Object,
      default: {},
    },
    // Copy text coming from properties files for search browse components
    searchBrowseI18n: {
      type: Object,
    },
    // indicates whether to show custom tabs
    showCustomTabs: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ProductAvailability,
      favorites,
      flyoutStatus,
      pdpProductInfo: {
        name: '',
        stock: '',
        price: '',
        baseOptions: '',
        featureList: '',
      },
      quantityValue: 1,
      size: '',
      counts: '',
      variantColor: '#000000',
      globals,
      sizeList: [],
      selectedVariant: null,
      countsList: [],
      scentList: [],
      bvInlineRating: 'BVRRInlineRating-',
      sizeOptionsObj: {},
      styleOptionsObj: {},
      sizeOptionsArr: [],
      styleOptionsArr: [],
      selectedPrimaryVariant: null,
      selectedPrimaryVariantIndex: null,
      selectedSecondaryVariantIndex: null,
      sizeArr: [],
      countArr: [],
      scentArr: [],
      colorArr: [],
      prodUrl: '',
      prodId: '',
      prodName: '',
      prodPrice: 0,
      refillProductsData: Object,
      styleArr: [],
      isActive: '',
      isFavoriteFilled: false,
      analyticsService: new AnalyticsService(),
      pdpService: new PdpService(),
      isSafari: /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
      isDownload: false,
      isOpen: false,
      showRating: true,
      showReviews: true,
      imgBlob: '',
      guestListName: '',
      loadPdfGenerator: false,
      sizeEnabled: false,
      scentEnabled: false,
      countEnabled: false,
      addToCartDisabled: false,
      firstVariantEnabled: false,
      secondVariantEnabled: false,
      pdpVariantTypes,
      styleVariantName: '',
      subscriptionChecked: [],
      subscriptionCheckedItems: '',
      buttonText: this.i18n.addToCart,
      subscriptionFrequency: [],
      userChosenFrequency: {},
      referenceTypes,
      soldIndividually: true,
      brandName: '',
      locateStoreURL: '',
      productSiteID: '',
    };
  },
  computed: {},
  async mounted() {
    this.onInit();
  },
  updated() {
    document.addEventListener('click', this.onClick);
    if (
      this.isMobile() &&
      document.body.scrollHeight > window.innerHeight &&
      document.getElementsByClassName('footer-section')[0] &&
      document.getElementsByClassName('cart-sticky-bottom')[0]
    ) {
      document.getElementsByClassName('footer-section')[0].style.paddingBottom =
        '70px';
    }
  },
  methods: {

    /**
     * Function is called on mounted which gets the product data
     */
    onInit() {
      const self = this;
      const requestConfig = {};
      requestConfig.data = {
        listName: this.listName,
      };

      self.pdpService.getProductData(
        {},
        this.handleSuccessResponse,
        this.handleErrorResponse,
        this.productId,
      );
    },

    /**
     * Function is called on the click of Find A Store button and navigates the user to Find A Store Page
     */
    findAStore() {
      let findStorePage = '';
      switch (this.globals.siteId) {
        case 'aria': {
          findStorePage = 'https://www.amazon.com/dp/B0711XJ9BR/ref=emc_b_5_t';
          window.open(findStorePage, '_blank');
          break;
        }
        case 'innovia': {
          findStorePage = 'https://www.amazon.com/stores/node/17978508011?_encoding=UTF8&field-lbr_brands_browse-bin=Innovia&ref_=bl_dp_s_web_17978508011';
          window.open(findStorePage, '_blank');
          break;
        }
        default : {
          findStorePage = this.globals.getNavBaseUrl() + this.globals.serviceUrls.locateStore;
          window.location.href = findStorePage;
          break;
        }
      }
    },

    /**
     * Function handles the response of get PDP data service which populates the PDP with the response
     */
    handleSuccessResponse(response) {
      // sending the data to Google Analytics on PDP page load
      this.analyticsService.trackImpressions(response.data);
      this.analyticsService.trackDetailImpressions(response.data);

      const statusObj = _.pickBy(response.data, _.isBoolean);
      const imagesObj = _.pick(response.data, ['images', 'name']);
      const productIconsData = _.pick(response.data, ['productIcons']);
      const thumbnailObj = {
        ...statusObj,
        ...imagesObj,
        ...productIconsData,
      };
      this.pdpProductInfo = response.data;
      this.bvInlineRating += response.data.code;
      response.data.showCustomTabs = this.showCustomTabs;
      eventBus.$emit('pdpProductsData', response.data);
      // Send data to Thumbnail Viewer
      eventBus.$emit('totalCarouselData', thumbnailObj);
    },
    /**
     * Function opens the selected variant of a product
     * @param  {String} url url of the variant of the product
     */
    /**
     * Function limits the characters in the data
     */
    limitCharacters(data) {
      let newData = data.length > 500 ? `${data.substring(0, 500)}...` : data;
      newData = this.replaceText(newData);
      return newData;
    },
    /**
     * Function replaces text
     */
    replaceText(text) {
      const mapObj = {
        '™': '(TM)',
        '’': "'",
        '–': '-',
        '…': '...',
        '<br>': '',
        '&bdquo;': '',
        '&euro;': 'E',
        '&ldquo;': '"',
        '”': '"',
        '„': ',',
        '€': 'E',
        Œ: '',
        '�': '',
        '“': '"',
        '&acirc;': '',
        '&oelig;': '',
        '&rsquo;': "'",
        '&mdash;': '-',
      };
      const newText = text.replace(
        /™|’|–|…|<br>|&bdquo;|&euro;|&ldquo;|”|„|€|Œ|�|&acirc;|&oelig;|&rsquo;|&mdash;|“/gi,
        matched => mapObj[matched],
      );
      return newText;
    },
    /**
     * Function is called when the download icon is clicked
     */
  },
};



// WEBPACK FOOTER //
// ./src/components/b2c/pdp/vx-pdp-product-info/vx-pdp-product-info.js